import { createSelector } from 'reselect';
import {
  getIsDataPersistent,
  getPersistentChatData,
} from 'store/services/session/selectors';

export const getChat = ({ chat }) => chat.data;

export const getChatData = state => {
  if (getIsDataPersistent(state)) {
    return getPersistentChatData(state);
  }

  return getSessionChatData(state);
};

export const getDialogId = ({ chat }) => chat.data.id;

// Session chat data is erased after closing the chat (ending current session)
export const getSessionChatData = ({ chat }) => chat.data.data;

export const getChatMeta = ({ chat }) => chat.meta;

export const getThread = ({ chat }) => chat.data.thread;

export const getHasThread = createSelector(
  getThread,
  thread => thread.length > 0,
);

export const getIsHistory = ({ chat }) => chat.isHistory;

export const getIsStarting = ({ chat }) => chat.start.isLoading;

export const getIsRetrying = ({ chat }) => chat.isRetrying;

export const getIsLoaded = ({ chat }) => chat.start.isLoaded;

export const getIsReStarting = createSelector(
  getIsLoaded,
  getIsStarting,
  (isLoaded, isStarting) => isLoaded && isStarting,
);

export const getIsAsking = ({ chat }) => chat.ask.isLoading;

export const getIsOpen = ({ chat }) => chat.isOpen;

export const getIsMinimized = ({ chat }) => chat.isMinimized;

export const getHasError = ({ chat }) => chat.start.error !== '';

export const getError = ({ chat }) => chat.start.error;

export const getIsChatDisabled = ({ chat }) => chat.isChatDisabled;

export const getIsDialogEnded = ({ chat }) => chat.isDialogEnded;

export const getWithAgent = ({ chat }) => chat.withAgent;

export const getMatchFeedbackType = ({ chat }) => chat.matchFeedbackType;

export const getAttachmentsConfig = ({ chat }) => chat.attachmentsConfig;

export const getSessionExpired = ({ chat }) => chat.isSessionExpired;

export const getIsAgentConnecting = ({ chat }) => chat.isAgentConnecting;

export const getIsAgentConnected = ({ chat }) => chat.isAgentConnected;

export const getIsAgentTimeout = ({ chat }) => chat.isAgentTimeout;

export const getIsSensitiveInput = ({ chat }) => Boolean(chat.isSensitiveInput);
